import { getAPIURLv2, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export interface BulkEmployeeRow {
	nombre1: string;
	nombre2?: string;
	apellido1: string;
	apellido2?: string;
	codigo_empleado?: string;
	dpi: string;
	email?: string;
	entidad: string;
	sucursal: string;
	dpi_jefe?: string;
	fecha_inicio?: string;
	email_personal?: string;
	iggs?: string;
	password: string;
	division?: string;
	equipo?: string;
	rol?: string;
}

export interface BulkUploadResult {
	created: number;
	linked: number;
	errors: { row: number; message: string }[];
}

export class BulkEmployees {
	/** @POST /pages/:pgid/hcm/bulk-employees */
	async upload(pgid: PGSchema.pages["id"], rows: BulkEmployeeRow[], token?: string) {
		return xhttp<BulkUploadResult>(
			`/pages/${pgid}/hcm/bulk-employees`,
			"POST",
			{ rows },
			{
				headers: token ? { "app-token": token } : undefined
			}
		);
	}

	getTemplateUrl(pgid: PGSchema.pages["id"]) {
		return `${getAPIURLv2()}/pages/${pgid}/hcm/bulk-employees/template`;
	}
}
